<template>
  <div class="container">
    <div class="modules">
      <div class="m0_wrap">
        <div class="statusBox" v-if="(visitorOutput.status == 1 || visitorOutput.status == 2 || visitorOutput.status == 5)&&mode=='1'">
          <div class="status_line" style="display:flex;align-item:center">
            <img v-if="visitorOutput.status == 2||visitorOutput.status == 5" class="success" :src="require(`../../../assets/images/icon_check_${$store.state.common.theme}.png`)" alt=""/>
            <span v-if="visitorOutput.status != 2&&visitorOutput.status != 5" class="line_icon"></span>
            <span class="line"></span>
            <img v-if="visitorOutput.status == 5" class="success" :src="require(`../../../assets/images/icon_check_${$store.state.common.theme}.png`)" alt=""/>
            <span v-if="visitorOutput.status != 5" class="line_icon"></span>
          </div>
          <div class="status_line" style="display:flex;align-item:center">
            <div class="text2">预约成功</div>
            <span class="line2"></span>
            <div class="text2">来访结束</div>

          </div>
          <!-- <div class="status_line" style="display:flex;align-item:center" v-if="visitorOutput.status != 5">
            <div class="text">2018-9-12 13:14:23</div>
            <span class="line3"></span>
            <div class="text"></div>
          </div> -->
        </div>
        <div class="statusBox" v-if="(visitorOutput.status == 1 || visitorOutput.status == 2 || visitorOutput.status == 5)&&mode=='0'">
          <div class="status_line" style="display:flex;align-item:center">
            <img v-if="visitorOutput.status == 1||visitorOutput.status == 2||visitorOutput.status == 5" class="success" :src="require(`../../../assets/images/icon_check_${$store.state.common.theme}.png`)" alt=""/>
            <span v-if="visitorOutput.status != 1&&visitorOutput.status != 2&&visitorOutput.status != 5" class="line_icon"></span>
            <span class="line"></span>
            <img v-if="visitorOutput.status == 2||visitorOutput.status == 5" class="success" :src="require(`../../../assets/images/icon_check_${$store.state.common.theme}.png`)" alt=""/>
            <span v-if="visitorOutput.status != 2&&visitorOutput.status != 5" class="line_icon"></span>
            <span class="line"></span>
            <img class="success" v-if="visitorOutput.status == 5" :src="require(`../../../assets/images/icon_check_${$store.state.common.theme}.png`)" alt=""/>
            <span v-if="visitorOutput.status != 5" class="line_icon"></span>
          </div>
          <div class="status_line" style="display:flex;align-item:center">
            <div class="text2">已发预约</div>
            <span class="line2"></span>
            <div class="text2">预约成功</div>
            <span class="line2"></span>
            <div class="text2">拜访结束</div>
          </div>
          <!-- <div class="status_line" style="display:flex;align-item:center" v-if="visitorOutput.status != 5">
            <div class="text">2018-9-12 13:14:23</div>
            <span class="line3"></span>
            <div class="text"></div>
          </div> -->
        </div>
        <div class="statusBox" v-if="visitorOutput.status == 3||visitorOutput.status == 6">
          <img class="statusIcon" src="../../../assets/images/visitHistory/fail.png" alt=""/>
          <div class="statusText">
            {{visitorOutput.status == 3?'预约失败':'审批未通过'}}
          </div>
        </div>
        <div class="statusBox" v-if="visitorOutput.status == 4">
          <img class="statusIcon" src="../../../assets/images/visitHistory/cancel.png" alt=""/>
          <div class="statusText">
            预约已取消
          </div>
        </div>
      </div>
    </div>
    <div class="modules " v-if="visitorOutput.status == 2 && visitorOutput.qrcode">
      <div class="m1_wrap">
        <div class="m1_text1">拜访门禁卡</div>
        <!-- <img :src="QRCode" class="m1_icon"/> -->
        <div  class="m1_icon" ref="qrCodeUrl" @click="refushQrCode"></div>
         <img v-if="visitorOutput.status !=2 ||isOut" class="qrCode_effect" src="../../../assets/images/icon_fk_take_effect.png">
        <div class="m1_text2">预约编号：{{visitorOutput.reserveNo}}</div>
        <div class="m1_text3">此二维码每3分钟刷新，当日有效</div>
      </div>
    </div>
    <div class="modules">
      <div class="title">
        <span class="modules_tag"></span><span class="modules_title">访客信息</span>
      </div>
      <div class="item">
        <span class="item_t1">访客姓名</span><span class="item_t2">{{visitorOutput.visitorUserName}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorMobile">
        <span class="item_t1">电话号码</span><span class="item_t2">{{visitorOutput.visitorMobile}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorIdType">
        <span class="item_t1">证件类型</span><span class="item_t2">{{visitorOutput.visitorIdType}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorId">
        <span class="item_t1">证件号码</span><span class="item_t2">{{visitorOutput.visitorId}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorType">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'拜访事由':'来访事由'}}</span><span class="item_t2">{{visitorOutput.visitorType}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorNum">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'拜访人数':'来访人数'}}</span><span class="item_t2">{{visitorOutput.visitorNum}}</span>
      </div>
      <div class="item" v-for="item in tbVisitorRegs" :key="item.regKey" v-if="item.regKey == 'visitor_is_fever' || item.regKey == 'visitor_is_mask' || item.regKey == 'visitor_arrive_wh'">
          <span class="item_t1 label_flex">{{item.regDicName}}</span>
          <span class="item_t2">{{item.regDicValue}}</span>
      </div>
       <div class="item" v-if="visitorOutput.visitorFaceUrl && visitorOutput.visitorFaceUrl !='NO'">
        <span class="item_t1">访客人脸</span><img class="visitorFace" :src="visitorOutput.visitorFaceUrl" />
      </div>
    </div>

    <div class="modules">
      <div class="title">
        <span class="modules_tag"></span><span class="modules_title">{{visitorOutput.visitorMode!=1?'拜访信息':'邀约信息'}}</span>
      </div>
      <div class="item">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'拜访时间':'来访日期'}}</span><span class="item_t2">{{visitorOutput.visitorDate}}</span>
      </div>
      <div class="item" v-if="visitorOutput.examineName">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'受访人':'邀约人'}}</span><span class="item_t2">{{visitorOutput.examineName}}</span>
      </div>
      <div class="item">
        <span class="item_t1">项目名称</span><span class="item_t2">{{visitorOutput.marketName}}</span>
      </div>
      <div class="item">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'拜访公司':'来访公司'}}</span><span class="item_t2">{{visitorOutput.visitorCompany}}</span>
      </div>
      <div class="item" v-if="visitorOutput.visitorFloor">
        <span class="item_t1">{{visitorOutput.visitorMode!=1?'拜访地址':'来访地址'}}</span><span class="item_t2">{{visitorOutput.visitorFloor}}</span>
      </div>

      <div class="item" v-if="visitorOutput.visitorMode==1">
        <span class="item_t1">邀约链接</span><span @click="copyLink" class="btn_duplicate" :data-clipboard-text="visitUrl">点击复制邀约链接</span>
      </div>

      

    </div>
    <div class="bottomBtn_wrap_h">
    </div>
    <div class="bottomBtn_wrap"  v-if="visitorOutput.status == 1 || visitorOutput.status == 2 || (visitorOutput.status == 5 && visitorOutput.isEvaluate === 0 && visitorOutput.hasTemp)">
      <div class="bottomBtn"  v-if="visitorOutput.status == 1 || visitorOutput.status == 2" @click="cancel">取消预约</div>
      <!-- <div class="bottomBtn" v-if="visitorOutput.status == 5 && visitorOutput.isEvaluate === 0 && visitorOutput.hasTemp && visitorOutput.visitorMode!=1" @click="evaluate">评价</div> -->
      <!-- <div class="bottomBtn" @click="viewEvaluate">查看评价</div> -->
    </div>
  </div>
</template>

<script>
import { getVisitorDetailById , cancelVisitorById,desEncrypt , transformToBase64 ,serversVisitUrl} from '../../../utils/api'
import util from "../../../utils/util";
import QRCode from 'qrcodejs2'
import Clipboard from 'clipboard';
let timer = '';
export default {
  name:"details",
  data () {
    return {
      visitorOutput:{},
      tbVisitorRegs:[],
      timestamp:'',
      QRCode:'',
      isToday:false,
      isOut:false,
      visitUrl :'',
      mode:'',
      
    };
  },
  created () {
    this.fetchData();
    this.mode = this.$route.query.mode
  },
  methods: {
    evaluate(){
    },
    viewEvaluate(){
    },

    refushQrCode(){
      // if(timer){
      //   clearTimeout(timer);
      //   timer=''
      // }
      this.getTenantQrCode(); 
    },
         //获取二维码数据
      getTenantQrCode() {
         //  var qobj = JSON.parse(this.visitorOutput.qrcode)
            var self =this;
            let content = {
                uid: this.visitorOutput.id,
                marketId: this.visitorOutput.marketId,
                operationType: "2",
                userId: this.visitorOutput.userId,
                timestamp:this.timestamp.toString()
            }
            desEncrypt(content).then(res => {
              console.log("获取门禁数据："+JSON.stringify(res))
              this.pageShow = true;
              this.hasData = true;
              this.creatQrCode(res);
            })
            if(!this.isOut){
              clearTimeout(timer)
              timer =  setTimeout(() => {
                self.fetchData();
                console.log("new data")
              }, 180000) //*60*3
            }
           // this.creatQrCode(content);
      },

      //js生成二维码
      creatQrCode(dic) {
        var map = dic;
        //{qrcode:code}  ;
        if(!this.qrcodeTool){
           var wh =document.body.clientWidth;
           var w =160*wh/375;
           var h =160*wh/375;
           console.log(wh+" =====  " + h);
            var qDarkcolor = '#000000';
           if(this.visitorOutput.status !=2 ||this.isOut){
                qDarkcolor ='#E6E6E6'
           }
           this. qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
                    text: dic,
                    //JSON.stringify(map).replace(/(\")/g,"\\$1"),
                    width: w,
                    height: h,
                    colorDark: qDarkcolor,
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.M
            })
        }else{
            this.qrcodeTool.clear(); // 清除代码
            this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
        }
      },
    getQRCode: function () {
      let content = {
        qrcode: this.visitorOutput.qrcode
      }
      transformToBase64(content).then(res => {
        if (res.res.code === 10000) {
          console.log("res二维码")
          console.log(res)
          this.QRCode = res.body.encodeBase64
        }
      });
    },
    cancel() {
      let self = this;
      util.showModal('温馨提示','确定取消吗？',true,'确定',
         function(){
            self.cancelVisitor();
        }, function(){
            console.log(0)
        })
    },
    //取消预约
   cancelVisitor(){
     let self = this;
      cancelVisitorById({
        "visitorId": this.$route.query.id
      }).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          self.fetchData();
        }
      })
    },
    fetchData(){
      getVisitorDetailById({
        "visitorId": this.$route.query.id
      }).then(res => {
        console.log('res')
         console.log(res)
         if(res.res.code == 10000){
           this.timestamp =res.res.timestamp;
           this.visitorOutput = res.body.visitorOutput
           this.tbVisitorRegs = res.body.tbVisitorRegs
           let date = new Date();
           var year = date.getFullYear()
           var month = date.getMonth() + 1;
           var day = date.getDate();

                    //  tdStr ="2019-12-12"
          //  var vdate = new Date(this.visitorOutput.visitorDate);
          //  var vyear = vdate.getFullYear()
          //  var vmonth = vdate.getMonth() + 1;
          //  var vday = vdate.getDate();
           var vdSrr = this.visitorOutput.visitorDate
           var str1 = vdSrr.substring(0,10)
           console.log(str1);
           var arr = str1.split('-')
                  //  var vdate = new Date(vdSrr);
                  //  console.log(vdate);
            var vyear = parseInt(arr[0])
                  //vdate.getFullYear()
            var vmonth = parseInt(arr[1])
                  //vdate.getMonth() + 1;
            var vday = parseInt(arr[2])
          // if(year<=vyear){
          //     if(month<=vmonth){
          //           if(day<=vday){
          //               this.isOut =false;
          //           }else{
          //               this.isOut=true;
          //           }
          //     }else{
          //          this.isOut=true;
          //     }
          // }else{
          //     this.isOut=true;
          // }
          if(year<=vyear){
              console.log(' in year')
              this.isOut=false;
              if(year==vyear){  //年相同才比较月
                    if(month<=vmonth){
                        console.log(' in month')
                        this.isOut=false;
                        if(month == vmonth){ //月相同才比较日期
                          if(day<=vday){
                              console.log(' in day')
                              this.isOut =false;
                          }else{
                              this.isOut=true;
                          }
                        }
                    }else{
                      this.isOut=true;
                    }
              }
          }else{ //当前年大于预约年 过期
              this.isOut=true;
          }

          var tdStr =year+"-"+month+"-"+day;

          if(vdSrr.indexOf(tdStr )>-1){
                this.isToday =true;
          }else{
               this.isToday =false;
          }
           //this.getQRCode()
           this.getTenantQrCode();
         }

      })
      // https://ics-mapi.spaceup.com.cn/visitAccessCard/294BF40C1E464FC1B9676201795B199B
      this.visitUrl  = serversVisitUrl +'/visitAccessCard/'+this.$route.query.id
    },
  
    copyLink() {
      var clipboard = new Clipboard('.btn_duplicate')
      clipboard.on('success', () => {
        util.showToast('邀约链接复制成功')
          // 释放内存
        clipboard.destroy()
      })
    },
  },
  destroyed() {
    clearTimeout(timer);
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  background:rgba(238,238,238,1);
  min-height: 100vh;
  .modules{
    margin-bottom: 14px;
    padding: 28px;
    box-sizing: border-box;
    background: #ffffff;
    .m0_wrap,.statusBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      .status_line{
        margin-bottom: 10px;
      }
      .success{
        width: 32px;
        height: 32px;
        margin: 10px;
      }
      .line_icon{
        width: 16px;
        height: 16px;
        margin: 18px;
        border-radius: 50%;
        background:rgba(218,218,218,1);
      }
      .line{
        display: inline-block;
        width: 186px;
        height: 2px;
        border-top:2px solid rgba(218, 218, 218, 1);
        margin: 25px 0
      }
      .text{
        width: 136px;
        line-height: 28px;
        color:rgba(153,153,153,1);
      }
      .text2{
        margin-bottom: 10px;
      }
      .line2{
        width: 124px;
      }
      .line3{
        width: 84px;
      }
      .statusIcon{
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
      }
      .statusText{
        text-align: center;
        color:rgba(102,102,102,1);
        font-size: 28px;
      }
    }
    .m1_wrap{
      display: flex;
      flex-direction: column;
      position: relative;
      align-items: center;
      .m1_text1{
        height:28px;
        font-size:24px;


        color:rgba(153,153,153,1);
        line-height:28px;
        margin-bottom: 28px;
      }
      .m1_icon{
        width: 320px;
        height: 320px;
        display: flex;
        margin-bottom: 28px;
        background: #f3f4f6;
      }
      .m1_text2{
        font-size:28px;
        color:rgba(51,51,51,1);
      }
       .m1_text3{
        margin-top: 10px;
        font-size:28px;
        margin-bottom: 10px;
        color:#999999;
      }
      .qrCode_effect{
        position: absolute;
        top: 52px;
        right: 12px;
        width: 120px;
        height: 120px;
      }
    }

    .title{
      display: flex;
      margin-bottom: 28px;
      .modules_tag{
        display: inline-block;
        width: 6px;
        height: 24px;
        margin: 10px 12px 12px 0;
        background:rgba(23,64,218,1);
      }
      .modules_title{
        height:44px;
        font-size:32px;

        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;
      }
    }
    .item{
      display: flex;
      margin-bottom: 20px;
      .item_t1,.item_t2{
        min-width:130px;
        font-size:26px;
        color:rgba(153,153,153,1);
        line-height:36px;
        margin-right: 36px;
      }
      .item_t2{
        color:rgba(51,51,51,1);
        margin-right: 0px;
      }
      .visitorFace{
          width: 180px;
          height: 180px;
      }
    }

  }
  .btn_duplicate{
      min-width:130px;
      font-size:26px;
      color:#0087ff;
      line-height:36px;
      margin-right: 36px;
  }
  .bottomBtn_wrap_h{
    height:108px;
  }
  .bottomBtn_wrap{
    width:100%;
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;
    bottom: 0;
    .bottomBtn{
      width:694px;
      height:76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      text-align: center;
      line-height: 76px;
      font-size:32px;
      color:rgba(255,255,255,1);
      margin: 16px 28px;
    }
  }

}
</style>
